import styled from "styled-components";

export default styled.dialog`
    border: none;
    bottom: 0;
    box-sizing: border-box;
    height: 100%;
    left: 50%;
    margin: 0;
    max-height: unset;
    position: fixed;
    top: 0;
    width: 50%;

    &::backdrop {
        background: #0007;
    }

    body:has(&[open]) {
        overflow: hidden;
    }
`;
